var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('QSubmenu',{attrs:{"title":"My Quility","subment":_vm.submenu,"buttons":_vm.buttons}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }